import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class RedirectToPhpGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (window.location.hostname === 'localhost') {
      window.location.assign(`https://training.syd1.fln-dev.net${state.url}`);
    } else {
      window.location.assign(state.url);
    }
    return <Observable<boolean>>Observable.never();
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/redirect-to-php-guard.service.ts